import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, interval, Subscription } from 'rxjs';
import { CucurachaAdminService } from '../service/cucuracha.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  updateStats: any
  usersCount: any;
  productsCount: any;
  accountsCount: any;
  vendorsCount: any
  constructor(private router: Router, private cs: CucurachaAdminService) { }
  reloadPage() {
    console.log(new Date(performance.timing.domLoading).getTime())

    var currentDocumentTimestamp = new Date(performance.timing.domLoading).getTime();
    // Current Time //
    var now = Date.now();
    // Total Process Lenght as Minutes //
    var tenSec = 3 * 1000;
    // End Time of Process //
    var plusTenSec = currentDocumentTimestamp + tenSec;
    console.log(currentDocumentTimestamp)
    console.log(now)

    if (now > plusTenSec) {
      location.reload();
    }
  }

  getAllUsersCount() {
    this.cs.getAllUsersCount().subscribe((data) => {
      this.usersCount = data
    })
  }
  getAllAccountsCount() {
    this.cs.getAllAccountsCount().subscribe((data) => {
      this.accountsCount = data
    })
  }
  getAllVendorsCount() {
    this.cs.getAllVendorsCount().subscribe((data) => {
      this.vendorsCount = data
    })
  }
  getAllProductsCount() {
    this.cs.getAllProductsCount().subscribe((data) => {
      this.productsCount = data
    })
  }

  ngOnInit(): void {
    this.getAllUsersCount();
    this.getAllProductsCount();
    this.getAllAccountsCount();
    this.getAllVendorsCount();

    // Reload Page Function //


    // You can call it in somewhere //
    // this.reloadPage();

  }

}
